<div class="headerdiv">
  <h1>Miles Management</h1>
</div>
<div class="card-body">
  <div class="row">
    <div class="col-md-12">
      <div class="form-div">
        <div class="row">
          <div class="m-portlet">
            <div>
              <div>
                <div>
                  <div class="col-lg-4">
                    <label> Miles to be awarded per 100 INR spent (X)</label>
                    <input type="text" class="form-control m-input" [(ngModel)]="submit.MILES_Value"
                      placeholder="Miles per 100">
                  </div>
                  <div class="col-lg-4">
                    <label>Nearest multiple no to be awarded (Y)</label>
                    <input type="text" class="form-control m-input" [(ngModel)]="submit.NEAREST_Value"
                      placeholder="Nearest multiple of">
                  </div>
                  <div class="btn clear-button button-margin">

                    <button style="margin-top: 20px !important;" class="btn btn-primary  commonbutt" type="button"
                      (click)="insertJpValue()">
                      Submit
                    </button>
                  </div>



                </div>
                <br />
                <div class="col-lg-4">
                  <h5> The Current Value of X is&nbsp;:&nbsp;{{Xvalue}} and Y is&nbsp;:&nbsp;{{Yvalue}} </h5>
                </div>
                <br />
                <div id="loder_div" style="display:none;text-align: center">
                  <h3>Values are saved successfully </h3>
                </div>

                <div *ngIf="loader">
                  <div style="margin:auto; text-align: center">
                    <img
                      src="https://vignette.wikia.nocookie.net/lego/images/b/b4/Loading_Animation.gif/revision/latest/scale-to-width-down/480?cb=20120528032206"
                      width="8%" height="8%" alt="Loader" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>